import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo512.png";
import styles from "./styles.stylesheet.module.scss";

export const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const storefrontUrl = "https://replayglasses.com";
  const productUrl = `${storefrontUrl}/products/replay-glasses-ai-note-taking-glasses`;

  return (
    <header className={styles.siteHeader}>
      <div
        className={styles.shippingBanner}
        role="region"
        aria-label="Shipping announcement"
      >
        <span aria-hidden="true">✦</span>
        <p>Free shipping on all orders</p>
        <span aria-hidden="true">✦</span>
      </div>

      <div className={styles.headerShell}>
        <a
          href={storefrontUrl}
          className={styles.brand}
          aria-label="Replay home"
        >
          <img src={logo} alt="" className={styles.brandLogo} />
          <span className={styles.brandName}>Replay</span>
        </a>

        <nav className={styles.desktopNav} aria-label="Main navigation">
          <a href={`${storefrontUrl}/#how-it-works`}>How it works</a>
          <a href={`${storefrontUrl}/#plans`}>Plans</a>
          <a href={`${storefrontUrl}/#faq`}>FAQs</a>
          <NavLink to="/updates">Updates</NavLink>
          <a
            href="https://docs.replayglasses.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Developer
          </a>
        </nav>

        <div className={styles.headerActions}>
          <a className={styles.appLink} href="/app">
            Go to App
          </a>
          <a className={styles.cartLink} href={`${storefrontUrl}/cart`}>
            Cart
          </a>
          <a className={styles.buyButton} href={productUrl}>
            Buy Now
          </a>
          <button
            className={styles.menuToggle}
            type="button"
            aria-expanded={isMenuOpen}
            aria-controls="MobileMenu"
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            Menu
          </button>
        </div>
      </div>

      <nav
        id="MobileMenu"
        className={styles.mobileNav}
        aria-label="Mobile navigation"
        hidden={!isMenuOpen}
      >
        <a href={`${storefrontUrl}/#how-it-works`}>How it works</a>
        <a href={`${storefrontUrl}/#plans`}>Plans</a>
        <a href={`${storefrontUrl}/#faq`}>FAQs</a>
        <NavLink to="/updates" onClick={() => setIsMenuOpen(false)}>
          Updates
        </NavLink>
        <a
          href="https://docs.replayglasses.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Developer
        </a>
        <a href="/app">Go to App</a>
        <a href={`${storefrontUrl}/cart`}>Cart</a>
        <a href={productUrl}>Buy Now</a>
      </nav>
    </header>
  );
};
